//统计一级学科分类
import requestCtxs from '@/sealFilter/requestCtxs'
export function queryBycondition(data) {
    return requestCtxs({
        url: '/core/ttv3/core/subject/typeinfo/query/bycondition',
        method: 'post',
        data
    })
}

//根据条件查询音视频信息，右边视频列表
export function audioInfo(data) {
    return requestCtxs({
        url: '/core/ttv3/core/audio/vedio/query/byconditon',
        method: 'post',
        data
    })
}

//根据条件分组查询音视频信息统计数量
export function audioGroup(data) {
    return requestCtxs({
        url: '/core/ttv3/core/audio/vedio/query/groupdata',
        method: 'post',
        data
    })
}

//根据资源ID查询详情资源列表，
export function audioList(data) {
    return requestCtxs({
        url: '/core/ttv3/core/audio/vedio/resc/query/byconditon',
        method: 'post',
        data
    })
}

//根据条件查询主题书单
export function getThemeName (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebooklist/querybycondition',
        method: 'post',
        data
    })
}

//根据书单pkid查询书单对应书目数据
export function listdetail (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebooklist/detail/query/bylistid',
        method: 'post',
        data
    })
}
//主体书单查询
export function themeList (data) {
    return requestCtxs({
        url: '/portal/ttv3/portal/ebooklist/detail/query/bykeyword',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/typeInfo.js